const { VUE_APP_BASE_URL, VUE_APP_API_BASE_URL, VUE_APP_REALTIME_BASE_URL, VUE_APP_REALTIME_PATH, VUE_APP_TILE_SERVER_BASE_URL, NODE_ENV = "" } = process.env;

const environment: "development" | "production" | "staging" = NODE_ENV.toLowerCase() as any;
const baseUrl = VUE_APP_BASE_URL;
const apiBaseUrl = VUE_APP_API_BASE_URL;
const realtimeBaseUrl = VUE_APP_REALTIME_BASE_URL || apiBaseUrl;
const realtimePath = VUE_APP_REALTIME_PATH;
const tileServerBaseUrl = VUE_APP_TILE_SERVER_BASE_URL;

export { environment, baseUrl, apiBaseUrl, realtimeBaseUrl, realtimePath, tileServerBaseUrl };
